<template>
  <el-dialog
    class="detail-dialog-container"
    :visible.sync="applyDialogVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :show-close="false"
    width="600px"
    center
    append-to-body>
    <div class="dialog-container flex flex-direction padding">
      <div class="dialog-header flex">
        <div class="dialog-title flex-sub">反馈信息</div>
        <i class="dialog-close el-icon-close" @click="cancel"></i>
      </div>
      <el-form class="form" :model="ruleForm" ref="ruleForm" labelWidth="auto">
        <blockquote v-for="(item,index) in ruleForm.lists" :key="index">
          <el-form-item :label="item.name" :prop="'lists.' + index + '.value'"
                        :rules="item.state === 1 ?{required: true, message: `请输入${item.name}`, trigger: 'blur'} : ''"
                        v-if="item.type === 1">
            <el-input v-model="item.value" placeholder="请输入" :disabled="readonly"></el-input>
          </el-form-item>
          <el-form-item :label="item.name" :prop="'lists.' + index + '.value'"
                        :rules="item.state === 1 ?{required: true, message: `请输入${item.name}`, trigger: 'blur'} : ''"
                        v-if="item.type === 2">
            <el-input v-model="item.value" placeholder="请输入" type="textarea" resize="none"
                      :autosize="{ minRows: 6, maxRows: 6 }" :disabled="readonly">
            </el-input>
          </el-form-item>
          <el-form-item :label="item.name" :prop="'lists.' + index + '.value'"
                        :rules="item.state === 1 ?{required: true, message: `请选择${item.name}`, trigger: 'change'} : ''"
                        v-if="item.type === 3">
            <el-select v-model="item.value" :disabled="readonly">
              <el-option
                v-for="option in item.option"
                :key="option"
                :label="option"
                :value="option">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="item.name" :prop="'lists.' + index + '.value'"
                        :rules="item.state === 1 ?{required: true, message: `请选择${item.name}`, trigger: 'change'} : ''"
                        v-if="item.type === 4">
            <el-select v-model="item.value" multiple :disabled="readonly">
              <el-option
                v-for="option in item.option"
                :key="option"
                :label="option"
                :value="option">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="item.name" :prop="'lists.' + index + '.value'"
                        :rules="item.state === 1 ?{required: true, message: `请上传${item.name}`, trigger: 'change'} : ''"
                        v-if="item.type === 5">
            <el-upload
              class="upload-demo"
              :class="{readonly:readonly}"
              :file-list="item.value"
              :on-preview="onPreview"
              :disabled="readonly">
            </el-upload>
          </el-form-item>
        </blockquote>
      </el-form>

      <div class="dialog-operate flex align-center justify-center" >
        <el-button class="operate black" @click="cancel">关闭</el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>

export default {
  name: "NoticeFeedbackShowDialog",
  props: {
    applyDialogVisible: {
      type: Boolean,
      default: false
    },
    json: { //详情ID
      type: String,
    },
  },
  data() {
    return {
      readonly: true,
      ruleForm: {
        lists: [],
      },

    }
  },
  created() {  },
  methods: {

    cancel() {
      this.$emit('feedbackState', false)
    },
    onPreview(file) {
      window.open(file.url)
    },
  },
  watch: {
    json() {
      if (this.json) {
        this.ruleForm.lists = JSON.parse(this.json)
      }
    }
  }
}
</script>

<style scoped lang="scss">
.el-select {
  width: 100%;
}

.detail-dialog-container {
  .dialog-container {
    .dialog-header {
      height: 55px;

      .dialog-title {
        font-size: 18px;
        font-weight: bold;
        color: #0a2240;
        text-align: center;
      }

      .dialog-close {
        font-size: 21px;
        color: #0a2240;
        font-weight: bold;
        cursor: pointer;
      }
    }

    .dialog-content {
      padding: 40px 80px;
      height: 605px;
      overflow-y: scroll;

      &::-webkit-scrollbar {
        display: none
      }

    }

    .dialog-operate {
      margin-top: 20px;

      .operate {
        width: 200px;
        height: 40px;
        border-radius: 20px;
        font-size: 16px;
        background-image: linear-gradient(37deg, #ffb400 0%, #fc7802 100%),
        linear-gradient(#ff9600, #ff9600);
        background-blend-mode: normal, normal;
        color: #ffffff;

        &.black {
          background: #0a2240 none;
        }
      }

      .operate + .operate {
        margin-left: 80px;
      }
    }

    .dialog-footer {
      height: 40px;
      background-color: #e7eff9;
      padding: 0 20px;
      border-radius: 0 0 10px 10px;

      .content {
        font-size: 16px;
        color: #8b9fbe;
      }
    }
  }
}
</style>